import { useState, useEffect } from 'react'

export const useDelayedLoading = (isLoading: boolean, delay = 1000) => {
  const [showLoading, setShowLoading] = useState(false)

  useEffect(() => {
    let timer: NodeJS.Timeout
    if (isLoading) {
      timer = setTimeout(() => setShowLoading(true), delay)
    } else {
      setShowLoading(false)
    }
    return () => clearTimeout(timer)
  }, [isLoading, delay])

  return isLoading && showLoading
}
